<template>
	<div class="main">
		<!-- Logo 区域 -->
		<div class="header">
			<div class="main-logo"></div>
		</div>

		<!-- 用户信息卡片 -->
		<router-link to="/userInfo" class="user-card">
			<div class="user-card-content">
				<div class="user-card-left">
					<div class="user-avatar">
						<span>星</span>
					</div>
					<div class="user-info">
						<div class="user-card-title">我的星礼卡</div>
						<div class="user-card-desc">点击查看个人信息</div>
					</div>
				</div>
				<div class="user-card-arrow">›</div>
			</div>
		</router-link>

		<!-- 功能入口 -->
		<div class="features">
			<router-link to="/qrcode" class="feature-item">
				<div class="feature-icon qr-icon">
					<svg viewBox="0 0 24 24" fill="currentColor">
						<path d="M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM13 13h2v2h-2zM15 15h2v2h-2zM13 17h2v2h-2zM17 13h2v2h-2zM19 15h2v2h-2zM17 17h2v2h-2zM15 19h2v2h-2zM19 19h2v2h-2z"/>
					</svg>
				</div>
				<span>付款码</span>
			</router-link>
			<router-link to="/historyOrder" class="feature-item">
				<div class="feature-icon history-icon">
					<img src="~@/assets/ic_time.png" alt="">
				</div>
				<span>历史订单</span>
			</router-link>
			<router-link to="/coupon" class="feature-item">
				<div class="feature-icon coupon-icon">
					<img src="~@/assets/order_icon_coupons.png" alt="">
				</div>
				<span>优惠券</span>
			</router-link>
			<router-link to="/PayCard2" class="feature-item">
				<div class="feature-icon gift-icon">
					<svg viewBox="0 0 24 24" fill="currentColor">
						<path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 00-5.12-2.12L12 3.76l-.88-.88A2.996 2.996 0 006 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 12 7.4l3.38 4.6L17 10.83 14.92 8H20v6z"/>
					</svg>
				</div>
				<span>星礼包</span>
			</router-link>
		</div>

		<!-- 提示区域 -->
		<div class="tips-section">
			<div class="tip-item">
				<div class="tip-icon">💡</div>
				<div class="tip-text">使用星礼卡支付可累积星星奖励</div>
			</div>
		</div>

		<!-- 底部操作按钮 -->
		<div class="bottom-actions">
			<router-link to="/PayCard" class="action-btn primary-btn">
				<span class="btn-icon">+</span>
				购买星礼卡
			</router-link>
			<router-link to="/bindCard" class="action-btn secondary-btn">
				绑定星礼卡
			</router-link>
		</div>
	</div>
</template>

<script>
	import store from "@/store";
	export default {
		data() {
			return {
				paycard: store.getters.getpaycard,
			}
		}
	}
</script>

<style lang="scss" scoped>
.main {
	min-height: 100vh;
	background: linear-gradient(180deg, #0d9488 0%, #059669 50%, #10b981 100%);
	display: flex;
	flex-direction: column;
	padding: 0 24px;
}

// 头部
.header {
	padding: 48px 0 32px;
	text-align: center;
}

.main-logo {
	width: 220px;
	height: 55px;
	background: url('~@/assets/logo_sbux.png') no-repeat center;
	background-size: contain;
	margin: 0 auto;
	filter: brightness(0) invert(1);
	opacity: 0.95;
}

// 用户信息卡片
.user-card {
	display: block;
	background: rgba(255, 255, 255, 0.95);
	border-radius: 24px;
	padding: 32px 28px;
	text-decoration: none;
	box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
	transition: transform 0.2s, box-shadow 0.2s;

	&:active {
		transform: scale(0.98);
	}
}

.user-card-content {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.user-card-left {
	display: flex;
	align-items: center;
	gap: 20px;
}

.user-avatar {
	width: 72px;
	height: 72px;
	background: linear-gradient(135deg, #059669, #10b981);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-size: 30px;
	font-weight: 600;
	box-shadow: 0 6px 16px rgba(16, 185, 129, 0.35);
}

.user-info {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.user-card-title {
	font-size: 32px;
	font-weight: 600;
	color: #1a1a2e;
}

.user-card-desc {
	font-size: 24px;
	color: #666;
}

.user-card-arrow {
	font-size: 44px;
	color: #999;
	font-weight: 300;
}

// 功能区域
.features {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 16px;
	margin-top: 32px;
}

.feature-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	padding: 24px 0;
	background: rgba(255, 255, 255, 0.95);
	border-radius: 20px;
	text-decoration: none;
	box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
	transition: transform 0.2s;

	&:active {
		transform: scale(0.95);
	}

	span {
		font-size: 22px;
		color: #333;
		font-weight: 500;
	}
}

.feature-icon {
	width: 56px;
	height: 56px;
	border-radius: 16px;
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		width: 32px;
		height: 32px;
	}

	svg {
		width: 30px;
		height: 30px;
	}
}

.history-icon {
	background: linear-gradient(135deg, #059669, #10b981);
}

.coupon-icon {
	background: linear-gradient(135deg, #f59e0b, #f97316);
}

.qr-icon {
	background: linear-gradient(135deg, #06b6d4, #0891b2);
	color: #fff;
}

.gift-icon {
	background: linear-gradient(135deg, #f59e0b, #f97316);
	color: #fff;
}

// 提示区域
.tips-section {
	margin-top: 32px;
	padding: 24px;
	background: rgba(255, 255, 255, 0.18);
	border-radius: 20px;
	backdrop-filter: blur(10px);
}

.tip-item {
	display: flex;
	align-items: center;
	gap: 12px;
}

.tip-icon {
	font-size: 28px;
}

.tip-text {
	font-size: 24px;
	color: rgba(255, 255, 255, 0.95);
}

// 底部操作按钮
.bottom-actions {
	display: flex;
	gap: 20px;
	padding: 32px 0 48px;
	margin-top: auto;
}

.action-btn {
	flex: 1;
	height: 100px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	border-radius: 50px;
	font-size: 30px;
	font-weight: 600;
	text-decoration: none;
	transition: transform 0.2s, box-shadow 0.2s;

	&:active {
		transform: scale(0.97);
	}
}

.btn-icon {
	font-size: 34px;
	font-weight: 300;
}

.primary-btn {
	background: #fff;
	color: #059669;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
}

.secondary-btn {
	background: rgba(255, 255, 255, 0.2);
	color: #fff;
	border: 2px solid rgba(255, 255, 255, 0.7);
	backdrop-filter: blur(10px);
}
</style>
